import { Box, Grid, Paper, Typography } from "@mui/material";
import { FC } from "react";
import { AttendanceSummary } from "src/apis/dashboardAttendance";

type AttendanceSummaryCardsProps = {
  summary: AttendanceSummary;
};

type CardConfig = {
  label: string;
  value: string | number;
  color?: string;
};

const AttendanceSummaryCards: FC<AttendanceSummaryCardsProps> = ({
  summary,
}): JSX.Element => {
  const cards: CardConfig[] = [
    { label: "Total de atendimentos", value: summary.total },
    { label: "Realizados", value: summary.completed, color: "#2e9e5b" },
    { label: "Marcados", value: summary.scheduled, color: "#3f9fff" },
    { label: "Cancelamentos", value: summary.cancelled, color: "#e0a106" },
    { label: "Faltas / no-show", value: summary.no_show, color: "#d64545" },
    {
      label: "Taxa de comparecimento",
      value: `${summary.taxa_comparecimento}%`,
      color: "#2e9e5b",
    },
    {
      label: "Taxa de cancelamento",
      value: `${summary.taxa_cancelamento}%`,
      color: "#e0a106",
    },
    { label: "Taxa de falta", value: `${summary.taxa_falta}%`, color: "#d64545" },
    { label: "Colaboradores atendidos", value: summary.colaboradores_unicos },
    { label: "Psicólogos ativos", value: summary.psicologos_ativos },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid item xs={6} sm={4} md={2.4} key={card.label}>
          <Paper
            elevation={1}
            sx={{
              height: "100%",
              padding: 2,
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
              borderTop: `3px solid ${card.color ?? "#9e9e9e"}`,
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {card.label}
            </Typography>
            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "flex-end" }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {card.value}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default AttendanceSummaryCards;
